import Controller from "./captainAppVersion.controller";
import template from "./captainAppVersion.html";

const captainAppVersion = {
  template,
  controller: Controller,
};

export default captainAppVersion;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersion/captainAppVersion.component.js